// Página Minha conta (M11): tabela AccountEntriesTable (livro caixa)
// completa com filtro por período e exportação CSV. Acessada via
// submenu Financeiro → Minha conta.
import React from 'react';
import { Typography } from 'antd';
import { getActiveTeamId } from '../../../utils/activeTeam';
import AccountEntriesTable from './AccountEntriesTable';

const { Title } = Typography;

export default function FinanceExtratoPage() {
  const teamId = getActiveTeamId();
  if (!teamId) return <div style={{ padding: 32, textAlign: 'center' }}>Escolha um time no seletor.</div>;
  return (
    <div style={{ padding: '16px 12px', maxWidth: 1200, margin: '0 auto' }}>
      <Title level={4} style={{ marginTop: 0, marginBottom: 16 }}>Minha conta</Title>
      <AccountEntriesTable communityTeamId={teamId} />
    </div>
  );
}
